// extracted by mini-css-extract-plugin
export default {"container":"FirstAccess_container__33Gs6","form":"FirstAccess_form__HxLSr"};